import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { Button, TablePagination, Typography, TextField, FormControl, Select, InputLabel } from "@mui/material";
import Grid from "@mui/material/Grid";
import moment from "moment";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import createInstance from "../../../api/axiosinstance";

const aiDishaApi = createInstance("DISHA");

// const districtCodes = {
//   Chittoor: 'CTR', Tirupati: 'TPTY', Kurnool: 'KNL', Nandyal: 'NDL', Anantapuramu: 'ATM', SriSathyaSai: 'SSS', "YSR Kadapa": 'YSR', Annamayya: 'AMA',
// };

const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "white",
  },
  "& label": {
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
      borderRadius: 10,
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
    "& .MuiInputBase-input": {
      color: "white",
    },
  },
}));

const CssFormControl = styled(FormControl)({
  '& label': {
    color: 'white',
    '&.Mui-focused': {
      color: 'white',
    },
  },
  '& .MuiInputBase-root': {
    color: 'white',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
      borderRadius: 10,

    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
    },
  },
});

const CssSelect = styled(Select)({
  '& .MuiSvgIcon-root': {
    color: 'white',
    textAlign: "center"
  },
});

const DistrictManagement = () => {
  const [states, setStates] = useState([]);
  const [selectedDistrictDetails, setSelectedDistrictDetails] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deactivateId, setDeactiveId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [isEdit, setIsEdit] = useState(false);
  const [district_name, setDistrict_name] = useState("");
  const [selectedState, setSelectedState] = useState("")
  const [districtCodes, setDistrictCodes] = useState("");
  const [districtCode, setDistrictCode] = useState("");
  const [districts, setDistricts] = useState([]);
  const [TableDistricts, setTableDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtIdToChange, setDistrictIdToChange] = useState("");
  const [actionType, setActionType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  
  useEffect(() => {
    fetchActiveStates();
    fetchDistricts();
  }, []);

  const fetchActiveStates = async () => {
    try {
      const response = await aiDishaApi.get("/Get_active_states");
      setStates(response.data);
      console.log("state data:", response.data);
    } catch (error) {
      console.error("Error fetching active states:", error);
    }
  };


  useEffect(() => {
    if (district_name === "") {
      setPage(0); // Reset pagination to the first page
      setIsEdit(false); // Exit edit mode
    }
  }, [district_name]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleEdit = async (districtId) => {
    try {
      if (!district_name.trim()) {
        Toast.error("District name cannot be empty");
        return;
      }

      const districtCode = districtCode[district_name] || "";

      // Make the PUT API call to update district details
      const response = await aiDishaApi.put(`/updating-district`, {
        districtid: districtId,
        district_name: district_name,
        disrtict_code: districtCode,
        state_name: selectedState,
      });

      if (response.status === 200) {
        Toast.success("District updated successfully");
        // fetchActiveStates();  // Refresh the district list
        setIsEdit(false);  // Exit edit mode
      } else {
        Toast.error("Failed to update district");
      }
    } catch (error) {
      console.error("Error while updating district:", error);
      Toast.error("Failed to update district");
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const fetchDistricts = async () => {
    try {
      const response = await aiDishaApi.get("/get-all-districts"); // Adjust endpoint as needed
      if (response.data && Array.isArray(response.data)) {
        setTableDistricts(response.data);
        console.log(" table districts 1", response.data)
        console.log(" table districts 2", TableDistricts)
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      Toast.error("Failed to fetch districts");
    }
  };
// useEffect(() => {
//   fetchDistricts()
//   console.log("table districts 3", TableDistricts);
//  }, [TableDistricts]);

  // const handleDropdownChange = (event) => {
  //   const selectedStateName = event.target.value;
  //   setSelectedState(selectedStateName);
  //   const stateObj = states.find((state) => state.state_name === selectedStateName);
  //   setStateCode(stateObj ? stateObj.state_code : "");
  //   console.log(selectedStateName)
  //   console.log(stateCode)
  // };

  const districtHeaders = [
    {
      District_Id: "District ID",
      State_name: "State Name",
      district_name: "District Name",
      disrtict_code: "District Code",
      creation_date: "Creation Date",
      action: "Action",
    },
  ];

  const rows = TableDistricts.map((district) => ({
    District_Id: district.district_id || district.District_Id,
    State_name: district.state_name || district.State_name,
    district_name: district.district_name,
    disrtict_code: district.district_code || district.disrtict_code,
    creation_date: district.creation_date ? moment(district.creation_date).format("DD/MM/YYYY") : "-",
    Status: district.Status || district.status
  }));

  const filteredRows = rows.filter((row) =>
    (row.State_name && row.State_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (row.district_name && row.district_name.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleClear = () => {
    setSelectedState("");
    setDistrict_name("");
    setSelectedDistrictDetails({});
    setSelectedDistrict("");
    // setSearchTerm("");
  };

  const handleSave = async (event) => {
     event.preventDefault();

  try {
    // Basic validations
    if (!selectedState || !selectedState.trim()) {
      Toast.error("State name cannot be empty");
      return;
    }
    if (!district_name.trim()) {
      Toast.error("District name cannot be empty");
      return;
    }
    if (!districtCode.trim()) {
      Toast.error("District code cannot be empty");
      return;
    }

    // API call
    const response = await aiDishaApi.post(
      `/add-district?state_name=${encodeURIComponent(selectedState)}`,
      {
        district_name: district_name,
        disrtict_code: districtCode,
      }
    );

    if (response.status === 200) {
      Toast.success("District saved successfully ✅");
      // fetchActiveStates();   // refresh list
      setDistrict_name("");  // reset field
      setDistrictCode("");   // reset code
      fetchDistricts()
    } else {
      Toast.error("Failed to save district ❌");
    }
  } catch (error) {
    console.error("Error while saving district:", error);
    Toast.error("Failed to save district ❌");
  }
};


  const fetchDistrictsForState = async (state) => {
    setSelectedState(state);

    try {
      const districtResponse = await aiDishaApi.get(`/filter_districts?state_name=${state}`);
      console.log("Districts data:", districtResponse.data);
      const { state_districts, district_code } = districtResponse.data;

    // Create mapping: { "Ariyalur": "ARL", "Chengalpattu": "CPT", ... }
    const combined = state_districts.map((name, index) => ({
      district_name: name,
      district_code: district_code[index]
    }));
    setDistricts(combined);
    } catch (error) {
      console.error("Error fetching data:", error);
      Toast.error("Failed to fetch district data");
    }
  };

  const handleModalOpen = (districtId, action) => {
    console.log("checking the status",districtId,action)
    setDistrictIdToChange(districtId);
    setActionType(action);
    setIsModalOpen(true);
  };

  const handleConfirm = async (districtid, currentStatus ) => {
        console.log("checking the status in confirm fun ---",districtid,currentStatus)

    await handleDeactivateDistrict(districtid, currentStatus );
    setIsModalOpen(false);
  };

  const handleDeactivateDistrict = async (districtid, currentStatus ) => {
    try {
      const newStatus = currentStatus  === "Active" ? "Inactive" : "Active";
      console.log("checking the id and status",districtid );
      const response = await aiDishaApi.patch(`/update_district_status?districtid=${districtid}&status=${newStatus}`
    );

      if (response.status === 200) {
        Toast.success("District deactivated successfully");
        fetchDistricts();
      }
    } catch (error) {
      console.error("Error deactivating district:", error);
      Toast.error("Failed to deactivate district");
    }
  };

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "30px",
          alignItems: "center",
          // background: alpha("#B9B9B9", 0.2),
          background: "#033538",
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}>
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: "white" }}
          >
            Add District
          </Typography>
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "16px", color: "white" }}
          >
            Add the Name of the District
          </Typography>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}>
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            State Name
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select State</InputLabel>
            <CssSelect
              label="state"
              id="demo-simple-select-outlined"
              size="small"
              value={selectedState}
              onChange={(e) => fetchDistrictsForState(e.target.value)}
              sx={{ width: '100%', textAlign: "center" }}>
              {!states || states.length === 0 ? (
                <MenuItem value="">No states available</MenuItem>
              ) : (
                states.map((state) => (
                  <MenuItem
                    key={state.state_id}
                    value={state.state_name}
                    sx={{ color: '#033538' }} // Make dropdown items visible
                  >
                    {state.state_name}
                  </MenuItem>
                ))
              )}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 3"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}
        >
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            Creation Date
          </Typography>
          <CssTextField
            value={creationDate + "(Auto)"}
            InputProps={{
              readOnly: true,
            }}
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "95%" }}
          />
        </Box>
        <Box
          gridColumn="span 2"
          sx={{ marginTop: "auto", textAlign: "center", marginBottom: "10px" }}
        >
          <Button onClick={handleClear}
            sx={{
              border: "1px solid",
              color: "white",
              width: "120px",
              height: "40px",
              borderRadius: "10px",
              fontFamily: "poppins",
            }}
          >
            clear
          </Button>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}>
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            District Name
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select District</InputLabel>
            <CssSelect
  label="district"
  id="demo-simple-select-outlined"
  size="small"
  value={selectedDistrict}
  onChange={(e) => {
    const districtName = e.target.value;
    setSelectedDistrict(districtName);
    setDistrict_name(districtName);
    // Auto-set district code when district is selected
    const selected = districts.find(d => d.district_name === districtName);
    setDistrictCode(selected?.district_code || "");
  }}
  sx={{ width: '100%', textAlign: "center" }}
>
  {!districts || districts.length === 0 ? (
    <MenuItem value="">No districts available</MenuItem>
  ) : (
    districts.map((district) => (
      <MenuItem
       key={district.district_code}
       value={district.district_name}
        sx={{ color: '#033538' }}
      >
         {district.district_name}
      </MenuItem>
    ))
  )}
</CssSelect>
          </CssFormControl>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            District Code
          </Typography>
          <CssTextField
             disabled
             label="District Code"
             id="custom-css-outlined-input"
             value={districtCode}
             size="small"
             sx={{width: "95%",
    "& .MuiInputBase-input.Mui-disabled": {
      color: "white",
      WebkitTextFillColor: "white",
    },
    "& .MuiInputLabel-root.Mui-disabled": {
      color: "rgba(255, 255, 255, 0.6)",
    },
  }}
  InputLabelProps={{
    style: { color: "white" },}}
             // InputLabelProps={{
             //   style: { color: "white" },
             // }}
           />
        </Box>

        <Box gridColumn="span 2" sx={{ marginTop: "auto", textAlign: "left" }}>
          <Button
            onClick={handleSave}
            sx={{
              background: "#006A71",
              width: "120px",
              height: "40px",
              borderRadius: "10px",
              fontFamily: "poppins",
            }}
          >
            <Typography sx={{ fontFamily: "poppins", color: "white" }}>
              Save
            </Typography>
          </Button>
        </Box>
      </Box>

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  {districtHeaders.map((n) => (
                    <TableRow key={n.District_Id}>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.District_Id}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.district_name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.disrtict_code}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.State_name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.creation_date}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
  {paginatedRows.length > 0 ? (
    paginatedRows.map((row) => {
      //console.log("Row inside table:", row);  // 👈 add here

      return (
      <TableRow
        key={row.District_Id}
        sx={{ backgroundColor: "#033538", marginRight: "30px" }}
      >
        <TableCell sx={{ color: "white", border: "1px solid black" }}>
          {row.District_Id || '-'}
        </TableCell>
        <TableCell sx={{ color: "white", border: "1px solid black" }}>
          {row.district_name || '-'}
        </TableCell>
        <TableCell sx={{ color: "white", border: "1px solid black" }}>
          {row.disrtict_code || '-'}
        </TableCell>
        <TableCell sx={{ color: "white", border: "1px solid black" }}>
          {row.State_name || '-'}
        </TableCell>
        <TableCell sx={{ color: "white", border: "1px solid black" }}>
          {row.creation_date || '-'}
        </TableCell>
        <TableCell sx={{ color: "white", border: "1px solid black" }}>
          {/* <Button
            variant="contained"
            onClick={() => handleEdit(row.District_Id)}
            sx={{
              backgroundColor: "black",
              color: "white",
              marginRight: "10px",
              fontFamily: "poppins",
              height: "20px",
              width: "30px",
            }}
          >
            Edit
          </Button> */}
          <Button
            variant="contained"
            sx={{
                  backgroundColor:
                    row.Status === "Active"
                      ? "#f44336"
                      : "#4caf50",
                  color: "#ffffff",
                  fontFamily: "poppins",
                  height: "24px",
                  padding: "2px 8px",
                  minWidth: "90px",
                  fontSize: "0.75rem",
            }}
            onClick={() => handleModalOpen(row.District_Id, row.Status)}
            color="error"
          >
             {row.Status === "Active"
                                ? "Deactivate"
                                : "Activate"}
          </Button>
        </TableCell>
      </TableRow>
    )
  })
  ) : (
    <TableRow>
      <TableCell colSpan={6} sx={{ textAlign: 'center', color: "#A7A7A7" }}>
        No districts found
      </TableCell>
    </TableRow>
  )}
</TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#006A71",
                  color: "white",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
        <Modal open={isModalOpen} onClose={handleModalClose}>
          <Typography>Are you sure you want to deactivate this District?</Typography>
          <Button onClick={handleConfirm}>Confirm</Button>
          <Button onClick={handleModalClose}>Cancel</Button>
        </Modal>
      </Box>

      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="District"
        action={() => handleDeactivateDistrict(districtIdToChange,actionType)}
        actionType={actionType === "Active" ? "Deactivate" : "Activate"}

      >
      </Modal>
    </div>
  );
};

export default DistrictManagement;